import { BrandLogo } from "@/components/shared/BrandLogo";

import { Link } from "react-router-dom";

export function AuthShell({ children, title, subtitle, image, eyebrow }) {
  return (
    <div className="grid min-h-screen md:grid-cols-2">
      <div className="relative hidden overflow-hidden md:block">
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="hero-overlay absolute inset-0" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Link to="/" data-testid="auth-brand-logo">
            <BrandLogo size="h-14 w-14" />
          </Link>
          <div className="max-w-md">
            <p className="font-serif text-2xl leading-snug">
              “True luxury is quiet, personal, and impossible to automate.”
            </p>
            <p className="mt-5 font-sans text-sm leading-relaxed text-[var(--aur-text-2)]">
              Aurelia Hospitality Group runs luxury hotels at Marina Bay, Sentosa Cove, Orchard and Fullerton Quay in Singapore.
              With one candidate profile you can apply for roles in front office, food and beverage, culinary, housekeeping,
              spa and wellness and more, upload your documents securely and follow every application from submission to offer.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center bg-[var(--aur-bg)] px-6 py-16">
        <div className="w-full max-w-sm fade-up">
          <Link to="/" className="mb-10 block md:hidden">
            <BrandLogo />
          </Link>
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h1 className="mt-3 font-serif text-3xl tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 font-sans text-sm text-[var(--aur-text-2)]">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}

export const authInput =
  "w-full rounded-md border border-[var(--aur-border)] bg-[var(--aur-bg-2)] px-3.5 py-3 font-sans text-sm text-[var(--aur-text)] placeholder:text-[var(--aur-text-2)] focus:border-gold focus:outline-none";

export const authButton =
  "w-full rounded-full bg-gold px-6 py-3 font-sans text-xs font-semibold uppercase tracking-widest text-[var(--aur-bg)] transition-all hover:bg-gold-bright disabled:opacity-60";
